import type { Filters } from '../lib/consts';
import SimpleSelect from './SimpleSelect';
import { LocationSelect } from './LocationSelect';
import * as consts from '../lib/consts';
import ClearableInput from './ui/ClearableInput';

type FilterControlsProps = {
    filters: Filters;
    setFilters: (filters: Filters) => void;
    displayCurrency: string;
    setDisplayCurrency: (currency: string) => void;
};

export default function FilterPanel({ filters, setFilters, displayCurrency, setDisplayCurrency }: FilterControlsProps) {
    const update = <K extends keyof Filters>(key: K, value: Filters[K]) => {
        setFilters({ ...filters, [key]: value });
    };

    const updateLocation = (value: string) => {
        update('location', value || '');
    };

    return (
        <div className="z-30 shrink-0 border-b border-gray-200 bg-white p-3 shadow-sm">
            <div className="grid grid-cols-1 items-center gap-3 sm:grid-cols-2 md:flex md:flex-wrap">
                <div className="min-w-[200px]">
                    <LocationSelect
                        value={filters.location}
                        onChange={updateLocation}
                    />
                </div>

                <SimpleSelect
                    options={consts.PRICE_RANGE_OPTIONS}
                    value={filters.price_range}
                    onChange={(val) => update('price_range', val)}
                    placeholder="Price Range"
                    isClearable
                    className="w-[150px]"
                />

                <SimpleSelect
                    options={consts.BEDROOM_OPTIONS}
                    onChange={(val: string | number) => update('min_bedrooms', val)}
                    value={filters.min_bedrooms as string}
                    isClearable
                    placeholder="Bedrooms"
                />

                <SimpleSelect
                    options={consts.DATE_RANGE_OPTIONS}
                    value={filters.dateRange}
                    onChange={(val: string) => update('dateRange', val as Filters['dateRange'])}
                    placeholder="Date Range"
                />

                <ClearableInput
                    placeholder="Keywords (eg pool, wifi, etc)"
                    inputClassName="border rounded px-3 py-2 text-sm"
                    divClassName="flex-1 min-w-[180px]"
                    value={filters.keywords}
                    onChange={value => update('keywords', value)}
                />

                <SimpleSelect
                    options={consts.SORT_OPTIONS}
                    value={filters.sort}
                    onChange={val => update('sort', val as Filters['sort'])}
                    className="w-[160px]"
                    isClearable={false}
                />

                <SimpleSelect
                    options={consts.DISPLAY_CURRENCIES}
                    value={displayCurrency}
                    onChange={val => setDisplayCurrency(val)}
                />

                <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded md:hidden"
                    onClick={() => document.getElementById('rental-list')?.scrollIntoView({ behavior: 'smooth' })}
                >
                    Show Results
                </button>
            </div>
        </div>
    );
}
